<template>
    <div xl:w-1200px mx-auto montserrat mt-30px mb-50px lg:w-1000px lt-lg:w-85-percent>
        <header>
            <div flex justify-between items-center lt-lg:flex-col lt-lg:gap-20px>
                <div v-if="logo" class="logo" style="max-width: 200px;">
                    <a target="_blank" :href="offer.web">
                        <img :src="'/img/logo/' + logo.filename" alt="Logo">
                    </a>
                </div>
                <div flex justify-between items-center gap-32px lt-lg:flex-col lt-lg:gap-20px>
                    <div text-14px flex gap-4 lt-sm:flex-col lt-sm:gap-20px lt-sm:items-center>
                        <a v-if="offer.cislo" :href="`tel:${offer.cislo}`" text-audit-primary no-underline>{{
                            offer.cislo }} | </a>
                        <a v-if="offer.email" :href="`mailto:${offer.email}`" text-audit-primary no-underline>{{
                            offer.email }} | </a>
                        <a v-if="offer.web" :href="offer.web" target="_blank" text-audit-primary no-underline>{{
                            offer.web }}</a>
                    </div>
                    <div flex flex-col gap-1>
                        <span v-if="offer.datum_vystavenia" text-14px text-audit-primary bg-audit-secondary px-12px
                            py-12px>
                            {{ $t('vystavenie_cp') }} : <span font-600>{{ offer.datum_vystavenia }}</span>
                        </span>
                        <span v-if="offer.user_provided_id" text-14px text-audit-primary bg-audit-secondary px-12px
                            py-12px>
                            {{ $t('cislo_ponuky') }} : <span font-600>{{ offer.user_provided_id }}</span>
                        </span>
                    </div>
                </div>
            </div>
            <div mt-38px lt-lg:mt-20px>
                <h1 text-20px text-audit-primary font-600 lt-lg:text-center>
                    {{ offer.verejny_nazov ? offer.verejny_nazov : $t('cenova_ponuka') }}
                </h1>
                <p text-16px text-audit-primary mt-12px font-400 lt-lg:text-center lt-lg:w-80-percent lt-lg:mx-auto>
                    <card-description :text="offer.text" :color="color" :type="type" :isentry="0" :text_center="true"></card-description>
                </p>
            </div>

            <div v-if="offer.isRows == 1" flex flex-wrap-nowrap gap-12px w-80 mt-50px mb-50px>
                <div v-for="row in price_rows" :key="row.id" flex flex-col gap-12px>
                    <div v-if="row.celkova == 1" flex flex-col bg-audit-primary p-15px rounded-5px w-min-260 h-min-120px justify-center>
                        <div text-14px text-audit-primary font-600 text-white>
                            {{ $t('cena_spolu') }}
                        </div>
                        <div text-25px text-audit-primary font-700 text-white>
                            {{ row.cena }}
                        </div>
                    </div>
                    <div v-else flex flex-col  border-solid border-audit-primary border-1px p-12px rounded-5px w-fit w-min-260 h-min-120px justify-center>
                        <div text-14px text-audit-primary font-600 >
                            {{ row.nazov }}
                        </div>
                        <div text-25px text-audit-primary font-700>
                            {{ row.cena }}
                        </div>
                    </div>
                </div>
            </div>
            <div mt-38px flex items-center justify-between lt-lg:flex-col lt-lg:gap-20px>
                <div flex flex-col bg-audit-secondary p-24px w-fit-content min-w-385px min-h-244px lt-sm:min-w-300px>
                    <span text-12px text-audit-tertiary font-700 mb-10px>Odberateľ:</span>
                    <div flex flex-col gap-2px>
                        <h1 v-if="klient.nazov" text-16px text-audit-primary font-700>{{ klient.nazov }}</h1>
                        <h2 v-if="klient.ulica" text-16px text-audit-primary font-400>{{ klient.ulica }}</h2>
                        <h2 v-if="klient.psc || klient.mesto" text-16px text-audit-primary font-400>{{ klient.psc + ' '
                            +
                            klient.mesto }}</h2>
                        <h2 v-if="klient.ico" text-16px text-audit-primary font-400 mt-15px>IČO: {{ klient.ico }}</h2>
                        <h2 v-if="klient.dic" text-16px text-audit-primary font-400>DIČ: {{ klient.dic }}</h2>
                        <h2 v-if="klient.icdph" text-16px text-audit-primary font-400>IČ DPH: {{ klient.icdph }}</h2>
                    </div>
                </div>
                <div flex flex-col border-solid border-audit-border border-1px p-24px w-fit-content min-w-385px
                    min-h-244px lt-sm:min-w-310px>
                    <span text-12px text-audit-tertiary font-700 mb-10px>Dodávateľ:</span>
                    <div flex flex-col gap-2px>
                        <h1 v-if="supplier.name" text-16px text-audit-primary font-700>{{ supplier.name }}</h1>
                        <h2 v-if="supplier.address" text-16px text-audit-primary font-400>{{ supplier.address }}</h2>
                        <h2 v-if="supplier.zip || supplier.town" text-16px text-audit-primary font-400>{{ supplier.zip +
                            ' ' + supplier.town }}</h2>
                        <h2 v-if="supplier.ico" text-16px text-audit-primary font-400 mt-15px>IČO: {{ supplier.ico }}
                        </h2>
                        <h2 v-if="supplier.dic" text-16px text-audit-primary font-400>DIČ: {{ supplier.dic }}</h2>
                        <h2 v-if="supplier.icdph" text-16px text-audit-primary font-400>IČ DPH: {{ supplier.icdph }}
                        </h2>
                    </div>
                </div>
            </div>
        </header>
        <div w-full  justify-center items-center gap-10px mt-20px flex lg:hidden>
            <i i-audit-hscroll w-40px h-40px flex justify-center items-center></i>
        </div>
        <section mt-38px lt-lg:mx-40px lt-sm:mx-10px lt-lg:mt-0px>
            <div class="table-container" w-full overflow-x-auto overflow-visible>
                <div min-w-900px w-full>
                    <div flex bg-audit-secondary px-12px py-8px items-center>
                        <div text-12px text-audit-tertiary font-700 flex-5>{{ $t('nazov_polozky') }}</div>
                        <div text-12px text-audit-tertiary font-700 flex-1>{{ $t('pocet') }}</div>
                        <div text-12px text-audit-tertiary font-700 flex-1>{{ $t('sadzba') }}</div>
                        <div text-12px text-audit-tertiary font-700 flex-1>
                            {{ has_offer_dph ? $t('spolu_bez_dph') : $t('spolu_dph') }}
                        </div>
                    </div>
                    <div v-for="entry in entries" :key="entry.id">
                        <div flex border-solid border-audit-border border-1px w-full mt-12px>
                            <div flex flex-col gap-12px flex-5 w-full>
                                <h1 text-16px text-audit-primary font-700 flex-5 pl-12px pt-12px>
                                    {{ entry.nazov }}
                                </h1>
                                <p v-if="!rolled.includes(entry.id)" text-14px text-audit-primary font-400 flex-1 w-80-percent pl-12px pb-20px>
                                    <card-description :text="entry.text" :color="color" :type="type"
                                        :isentry="1"></card-description>
                                </p>
                            </div>
                            <div flex-1 pt-7px border-l-solid border-audit-border border-1px>
                                <span text-14px text-audit-primary font-700 pl-12px>
                                    {{ formatHours(entry) }}
                                </span>
                            </div>
                            <div flex-1 pt-7px border-l-solid border-audit-border border-1px>
                                <span text-14px text-audit-primary font-700 pl-12px>
                                    {{ formatQuantity(entry) }}
                                </span>
                            </div>
                            <div flex-1 flex justify-end border-l-solid border-audit-border border-1px>
                                <div v-if="entry.zlava && parseFloat(entry.zlava) > 0" flex flex-col gap-5px items-end pr-12px
                                    pt-12px>
                                    <div rounded-2px h-20px text-10px font-700 bg-audit-red text-white flex items-center
                                        justify-center px-5px>
                                        {{ entry['formatedData']['zlavaText'] }}
                                    </div>
                                    <div flex flex-col gap-2px items-end>
                                        <span text-16px text-audit-primary font-700>
                                            <span
                                                v-if="offer.new == 1 && entry.type_cena == 3 || offer.new != 1 && entry.type_cena == 2">
                                                {{ $t('spolu') }}
                                            </span>
                                            {{
                                                formatPrice(entry, false)
                                            }}
                                        </span>
                                        <span text-12px text-audit-discount font-400 line-through>
                                            <span
                                                v-if="offer.new == 1 && entry.type_cena == 3 || offer.new != 1 && entry.type_cena == 2">
                                                {{ $t('spolu') }}
                                            </span>
                                            {{
                                                formatPrice(entry, true)
                                            }}
                                        </span>
                                    </div>
                                </div>
                                <span v-else text-14px text-audit-primary font-700 pr-12px pt-7px>
                                    <span
                                        v-if="offer.new == 1 && entry.type_cena == 3 || offer.new != 1 && entry.type_cena == 2">
                                        {{ $t('spolu') }}
                                    </span>
                                    {{
                                        formatPrice(entry, false)
                                    }}
                                </span>
                                <i w-12px h-12px i-audit-roll pt-35px mr-7px cursor-pointer transition-transform duration-300 
                                :class="{ 'rotate-180': rolled.includes(entry.id) }" @click="rollEntry(entry)"></i>
                            </div>
                        </div>
                        <div v-if="!rolled.includes(entry.id)" flex flex-col>
                            <div v-for="subentry in entry.subentries" :key="subentry.id" flex border-solid border-audit-border
                                border-1px w-full>
                                <div w-full flex>
                                    <div flex gap-12px flex-5 py-7px>
                                        <span w-9px h-2px bg-audit-border mt-7px ml-12px>
                                        </span>
                                        <div flex flex-col gap-12px>
                                            <h1 text-16px text-audit-primary font-400 flex-5>
                                                {{ subentry.nazov_polozka }}
                                            </h1>
                                            <p v-if="subentry.text_polozka" text-14px text-audit-primary font-400 flex-1
                                                w-80-percent pb-12px>
                                                <card-description :text="subentry.text_polozka" :color="color" :type="type"
                                                    :isentry="2"></card-description>
                                            </p>
                                        </div>
                                    </div>
                                    <div flex-1 pt-7px border-l-solid border-audit-border border-1px>
                                        <span text-14px text-audit-primary font-400 pl-12px>
                                            {{ formatSubHours(subentry) }}
                                        </span>
                                    </div>
                                    <div flex-1 pt-7px border-l-solid border-audit-border border-1px>
                                        <span text-14px text-audit-primary font-400 pl-12px>
                                            {{ formatSubQuantity(subentry) }}
                                        </span>
                                    </div>
                                    <div flex-1 pt-7px flex justify-end border-l-solid border-audit-border border-1px>
                                        <span text-14px text-audit-primary font-400 pr-12px>
                                            {{
                                                subentry.isCenaRange ?
                                                    subentry.formattedCena + ' - ' + subentry.formattedCenaDo + ' ' + currency_symbol :
                                                    subentry.formattedCena + ' ' + currency_symbol
                                            }}
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section mt-38px flex justify-between lt-lg:flex-col lt-lg:gap-20px>
            <div flex flex-col gap-8px lt-lg:items-center>
                <div v-if="offer.confirmed_status && (offer.form_status == 0 || offer.form_status == null)" flex
                    flex-col gap-10px bg-audit-secondary p-24px w-385px lt-sm:w-90-percent>
                    <div text-16px text-audit-primary font-600>
                        {{ $t('suhlasite_s_cp') }}
                    </div>
                    <div flex gap-12px>
                        <div id="prijat" cursor-pointer w-160px h-54px bg-audit-primary text-white font-600 rounded-2px
                            flex gap-12px items-center justify-center>
                            <i w-12px h-12px i-audit-check></i>
                            {{ $t('suhlasite_y_btn') }}
                        </div>
                        <div id="odmietnut" cursor-pointer w-160px h-54px bg-white text-audit-primary font-600
                            rounded-2px flex gap-12px items-center justify-center>
                            <i w-12px h-12px i-audit-times></i>
                            {{ $t('suhlasite_n_btn') }}
                        </div>
                    </div>
                    <prijat-ponuku :color="new_color" :offer_id="offer.id"></prijat-ponuku>
                    <odmietnut-ponuku :color="new_color" :offer_id="offer.id"></odmietnut-ponuku>
                </div>
                <div v-else-if="price_agreement" flex flex-col gap-10px bg-audit-secondary p-24px w-385px lt-sm:w-90-percent>
                    <div text-16px text-audit-primary font-600>
                        {{ price_agreement.confirmed == 1 ? $t('suhlasite_y_odoslanie') : $t('suhlasite_n_odoslanie') }}
                        {{ price_agreement.date }}
                    </div>
                </div>
                <div cursor-pointer w-385px h-43px justify-center border-solid border-audit-primary border-1px
                    rounded-6px flex gap-8px items-center lt-sm:w-90-percent
                    @click="downloadPdf">
                    <i w-12px h-12px i-audit-pdf></i>
                    <span text-16px text-audit-primary font-500>
                        {{ $t('pdf') }}
                    </span>
                </div>
            </div>
            <div flex flex-col gap-8px lt-lg:items-center>
                <div v-if="offer.show_price_box" flex flex-col bg-audit-primary w-min-415px rounded-3px lt-sm:w-min-90-percent>
                    <div v-if="parseFloat(offer.zlava) > 0" flex justify-between items-center border-b-solid border-audit-tertiary border-1px>
                        <div flex justify-between items-center w-full px-12px py-14px>
                            <span text-16px text-white font-600>
                                {{ has_offer_dph ? $t('cena_bez_dph') : $t('cena_spolu') }}
                            </span>
                            <div flex gap-12px>
                                <div rounded-2px w-64px h-20px text-12px font-600 bg-audit-red text-white flex
                                    items-center justify-center>
                                    {{$t('zlava')}} {{offer.zlava}} %
                                </div>
                                <div text-16px text-white font-600 line-through>
                                    {{
                                        price_data.isCenaRange ?
                                            price_data.cena_before_discount + ' - ' + price_data.cena_do_before_discount + ' ' + currency_symbol :
                                            price_data.cena_before_discount + ' ' + currency_symbol
                                    }}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div flex justify-between items-center>
                        <div flex justify-between items-center w-full px-12px pt-12px pb-6px>
                            <span text-20px text-white font-600>
                                {{ has_offer_dph ? $t('cena_bez_dph') : $t('cena_spolu') }}
                            </span>
                            <div text-22px text-white font-600>
                                {{
                                    price_data.isCenaRange ?
                                        price_data.cena_without_dph + ' - ' + price_data.cena_do_without_dph + ' ' + currency_symbol :
                                        price_data.cena_without_dph + ' ' + currency_symbol
                                }}
                            </div>
                        </div>
                    </div>
                    <div v-if="has_offer_dph" flex justify-between items-center>
                        <div flex justify-between items-center w-full px-12px pb-12px pt-6px>
                            <span text-14px text-white font-600>
                                {{$t('cena_s_dph')}}
                            </span>
                            <div text-14px text-white font-600>
                                {{
                                    price_data.isCenaRange ?
                                        price_data.cena_zlava + ' - ' + price_data.cena_do_zlava + ' ' + currency_symbol :
                                        price_data.cena_zlava + ' ' + currency_symbol
                                }}
                            </div>
                        </div>
                    </div>
                </div>
                <div v-if="offer.dodanie" bg-audit-secondary p-12px cursor-pointer relative>
                    <div flex justify-between items-center>
                        <div flex items-center gap-5px relative>
                            <div v-if="offer.dodanie_text" class="agree_tooltip"
                                :style="{ opacity: showTooltip ? 1 : 0 }" text-audit-primary bg-audit-secondary
                                after:bg-audit-secondary>
                                {{ offer.dodanie_text }}
                            </div>
                            <i w-20px h-20px i-audit-info @mouseenter="showTooltip = true" @mouseleave="showTooltip = false"></i>
                            <span text-16px text-audit-primary font-500>
                                {{ $t('dodanie') }} {{ offer.dodanie }}
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section mt-150px v-if="offer.reviews == '1'">
            <price-reviews :items="reviews" :new_color="new_color" :color="color" :type="type" :compact_version="0">
            </price-reviews>
        </section>
        <footer mt-150px lt-lg:mt-50px pt-40px>
            <div flex justify-between items-center lt-lg:flex-col lt-lg:gap-20px>
                <div flex flex-col gap-1>
                    <span v-if="offer.datum" text-14px text-audit-primary bg-audit-secondary px-12px py-12px>
                        {{ $t('platnost_cp') }} : <span font-600>{{ offer.datum }}</span>
                    </span>
                </div>
                <div ml-30px v-if="user.offer_footer_logo != 1 && offer.footer_logo != 1" flex flex-col gap-1 items-center justify-center>
                    <small text-12px text-audit-primary mb-10px>{{$t('pekne_cp_od')}} </small>
                    <a target="_blank" href="https://www.doffero.com/">
                        <img src="/img/price/white/doffero_logo.svg" alt="doffero_logo" width="180px">
                    </a>
                </div>
                <div text-12px flex gap-2 lt-sm:flex-col lt-sm:gap-20px lt-sm:items-center>
                    <a v-if="offer.cislo" :href="`tel:${offer.cislo}`" text-audit-primary no-underline>{{ offer.cislo }}
                        |
                    </a>
                    <a v-if="offer.email" :href="`mailto:${offer.email}`" text-audit-primary no-underline>{{ offer.email
                    }} | </a>
                    <a v-if="offer.web" :href="offer.web" target="_blank" text-audit-primary no-underline>{{ offer.web
                    }}</a>
                </div>
            </div>
        </footer>
    </div>

</template>

<script>
export default {
    name: 'Auvid',
    props: [
        'logo',
        'offer',
        'reviews',
        'new_color',
        'color',
        'type',
        'klient',
        'supplier',
        'has_offer_dph',
        'entries',
        'currency_symbol',
        'price_agreement',
        'price_data',
        'price_rows',
        'company',
        'user'
    ],
    data() {
        return {
            showTooltip: false,
            rolled: [],
        }
    },
    mounted() {
        this.rolled = this.entries.map(entry => entry.id);
    },
    methods: {
        rollEntry(entry) {
            if (this.rolled.includes(entry.id)) {
                this.rolled = this.rolled.filter(id => id !== entry.id);
            } else {
                this.rolled.push(entry.id);
            }
        },
        formatHours(entry) {
            if (!entry.pocet_hodin) return "";
            const { pocet_hodin, pocet_hodin_do, jednotka } = entry;
            if (pocet_hodin_do && parseFloat(pocet_hodin_do) > 0) {
                if (jednotka) {
                    return jednotka === "hodiny"
                        ? `${pocet_hodin} - ${pocet_hodin_do} ${this.$t("hodina")}`
                        : `${pocet_hodin} - ${pocet_hodin_do} ${jednotka}`;
                }
                return `${pocet_hodin} - ${pocet_hodin_do}`;
            } else {
                if (jednotka) {
                    return jednotka === "hodiny"
                        ? `${pocet_hodin} ${this.$t("hodina")}`
                        : `${pocet_hodin} ${jednotka}`;
                }
                return `${pocet_hodin}`;
            }
        },
        formatQuantity(entry) {
            const { hodinova_sadzba, jednotka } = entry;
            if (!hodinova_sadzba) return "";
            if (jednotka) {
                if (jednotka == "hodiny") {
                    return `${hodinova_sadzba}  ${this.currency_symbol} / ${this.$t("hodina")}`;
                } else {
                    return `${hodinova_sadzba} ${this.currency_symbol} / ${jednotka}`;
                }
            }
            return `${hodinova_sadzba}  ${this.currency_symbol}`;
        },
        formatPrice(entry, isDiscount) {
            if (isDiscount) {
                return entry['formatedData']['isCenaRange']
                    ? entry['formatedData']['formattedCena'] + ' - ' + entry['formatedData']['formattedCenaDo']
                    : entry['formatedData']['formattedCena']
                    + ' ' + this.currency_symbol
            } else {
                return entry['formatedData']['isCenaRange']
                    ? entry['formatedData']['formattedCenaZlava'] + ' - ' +
                    entry['formatedData']['formattedCenaZlavaDo']
                    : entry['formatedData']['formattedCenaZlava']
                    + ' ' + this.currency_symbol
            }
        },
        formatSubHours(subentry) {
            if (!subentry.hodiny_polozka) return "";
            const { hodiny_polozka, hodiny_do_polozka, jednotka_polozka } = subentry;

            if (hodiny_do_polozka && parseFloat(hodiny_do_polozka) > 0) {
                if (jednotka_polozka) {
                    return jednotka_polozka === "hodiny"
                        ? `${hodiny_polozka} - ${hodiny_do_polozka} ${this.$t('hodina')}`
                        : `${hodiny_polozka} - ${hodiny_do_polozka} ${jednotka_polozka}`;
                }
                return `${hodiny_polozka} - ${hodiny_do_polozka}`;
            } else {
                if (jednotka_polozka) {
                    return jednotka_polozka === "hodiny"
                        ? `${hodiny_polozka} ${this.$t('hodina')}`
                        : `${hodiny_polozka} ${jednotka_polozka}`;
                }
                return `${hodiny_polozka}`;
            }
        },
        formatSubQuantity(subentry) {
            const { sadzba_polozka, jednotka_polozka } = subentry;
            if (!sadzba_polozka) return "";
            if (jednotka_polozka) {
                return jednotka_polozka === "hodiny"
                    ? `${sadzba_polozka} ${this.currency_symbol} /${this.$t('hodina')}`
                    : `${sadzba_polozka} ${this.currency_symbol} /${jednotka_polozka}`;
            }
            return `${sadzba_polozka} ${this.currency_symbol}`;
        },
        downloadPdf() {
            window.open(`/pdf/${this.offer.uuid}/${this.company.slug}/${this.offer.id}`, '_blank');
        }
    },
    mounted () {
        var modal1 = document.getElementById("prijat_modal");
        var btn1 = document.getElementById("prijat");
        var span1 = document.getElementById("close_prijat");
    
        var modal2 = document.getElementById("odmietnut_modal");
        var btn2 = document.getElementById("odmietnut");
        var span2 = document.getElementById("close_odmietnut");

        if (btn1) {
            btn1.onclick = function() {
                modal1.style.display = "block";
            }
        }
        if (btn2) {
            btn2.onclick = function() {
                modal2.style.display = "block";
            }
        }
        if (span1) {
            span1.onclick = function() {
                modal1.style.display = "none";
            }
        }
        if (span2) {
            span2.onclick = function() {
                modal2.style.display = "none";
            }
        }
        
    },
}
</script>

<style lang="scss" scoped>
.agree_tooltip {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 150px;
    box-shadow: 0px 2px 2px rgba(143, 153, 179, 0.2);
    border-radius: 3px;
    font-weight: 800;
    font-size: 14px;
    line-height: 18px;
    padding: 10px;
    position: absolute;
    bottom: 35px;
    z-index: 10;
    transition: opacity 0.5s ease-in-out;
}

.agree_tooltip::after {
    content: "";
    width: 15px;
    height: 15px;
    position: absolute;
    left: 5px;
    bottom: -3px;
    transform: rotate(45deg);
    border-radius: 3px;
}

.table-container {
    width: 100%;
    position: relative;
}

@media (min-width: 800px) {
    .table-container {
        overflow-x: auto;
        -webkit-overflow-scrolling: touch;
    }
}
</style>